<template>
  <ProgressSpinner />
</template>

<script>
import api from "@/api";

export default {
  mounted() {
    const token = this.$route.query.token;
    if (token) {
      api
        .confirmUserByToken(token)
        .then(response => {
          this.$store.commit("setUser", response.data);
          this.makeToast("success", this.$t("account-verified"));
          if (response.data.email_changed) {
            this.goRouter("/");
          } else {
            this.goRouter("/sign-up/wizard");
          }
        })
        .catch(error => {
          console.log("Error:", error);
        });
    }
  },
};
</script>
